import React from 'react';
import Entry from '../components/Entry';
import EntryConfig from '../components/entryconfigType';
import '../Default.css';
import './Places.css';
import { Routes, Route } from "react-router-dom";
import type City from './placesType';
// import PlaceRender from "./PlaceRender"

import places_file from "./places.json"
import CitiesRender from './CitiesRender';
const cities: City[] = places_file as any;



const menuItems: EntryConfig[] = cities.map((entry,index) =>
  {
    return {
      img: entry.img.src,
      img_alt: entry.name,
      link: `./${index}`,
      text: entry.name
    } as EntryConfig
  }
)


function PlacesMenu(){
  return (
    <>
        <div className="page-title">
          Miejsca
        </div>
        <div className="navigation-wraper">
          <nav className='small-nav-bar navigation-bar'>
            {menuItems.map((v,i) => <Entry conf={v} key={i}/>)}
          </nav>
          <div style={{textAlign: 'center', fontSize: '7px'}}>
            {cities.map((city,city_index) => <div key={city_index}>
              {city.img.author && <div>
                {city.name} icon: <div dangerouslySetInnerHTML={{ __html: city.img.author }}></div>
              </div>}
            </div>)}
          </div>
        </div>
        
    </>
  )
}

function Places() {
    return (
      <>
          <Routes>
            <Route path='/' element={PlacesMenu()}></Route>
            {cities.map((entry,index) => 
              <Route path={`/${index}/*`} key={index.toString()} element={<CitiesRender city={entry}/>}/>
            )}
          </Routes>
      </>
    );
}

export default Places;